import { useContext } from 'react';
import { AuthContext } from '../contexts/jwt-auth-context';
// import { AuthContext } from '../contexts/google-auth-context';

export const useAuth = () => useContext(AuthContext);
